<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-breakpoint="960"
    clipped
    :right="$vuetify.rtl"
    width="300"
    mini-variant-width="70"
    :mini-variant="expandOnHover"
    :expand-on-hover="expandOnHover"
    app
    id="main-sidebar"
    v-bar
  >
    <div class="gpr-sidebar-head" aria-label="Surexport">
      <div class="gpr-sidebar-brand">
        <img class="gpr-sidebar-brand__logo gpr-sidebar-brand__logo--full" :src="clientLogo" alt="Surexport" />
        <img class="gpr-sidebar-brand__logo gpr-sidebar-brand__logo--mark" :src="clientMarkLogo" alt="Surexport" />
      </div>
      <div class="gpr-sidebar-profile" @click="openProfileConfig(false)" :title="profileTooltip">
        <v-avatar class="gpr-sidebar-profile__avatar" size="38">
          <v-img v-if="profilePhoto" :src="profilePhoto" />
          <span v-else>{{ profileInitial }}</span>
        </v-avatar>
        <div class="gpr-sidebar-profile__info">
          <p class="gpr-sidebar-profile__name">{{ profileName }}</p>
          <p class="gpr-sidebar-profile__role">{{ profileRole }}</p>
        </div>
        <v-btn
          icon
          small
          class="gpr-sidebar-profile__action"
          title="Configurar perfil"
          aria-label="Configurar perfil"
          @click.stop="openProfileConfig(false)"
        >
          <v-icon small>mdi-cog-outline</v-icon>
        </v-btn>
      </div>
    </div>
    <v-list expand nav class="mt-1">
      <v-divider></v-divider>
      <template v-for="(item, i) in items">
        <!---If Sidebar Caption -->
        <v-row v-if="item.header" :key="item.header" align="center">
          <v-col v-if="verifyAuthAcl(item.meta.code)" cols="12">
            <v-subheader v-if="item.header" class="d-block text-truncate">{{ item.header }}</v-subheader>
          </v-col>
        </v-row>
        <!---If Sidebar Caption -->
        <div v-else-if="item.children" :key="`div-group-${i}`">
          <BaseItemGroup v-if="verifyAuthAcl(item.meta.code)" :key="`group-${i}`" :item="item"></BaseItemGroup>
        </div>

        <div v-else :key="`div-item-${i}`">
          <BaseItem v-if="verifyAuthAcl(item.meta.code)" :key="`item-${i}`" :item="item" />
        </div>
      </template>
      <!---Sidebar Items -->
    </v-list>
    <v-dialog v-model="profileDialog" max-width="520">
      <v-card class="gpr-profile-dialog">
        <v-card-title class="gpr-profile-dialog__title">
          <v-avatar class="gpr-profile-dialog__avatar" size="72">
            <v-img v-if="profilePreview" :src="profilePreview" />
            <v-icon v-else size="34">mdi-account-outline</v-icon>
          </v-avatar>
          <div>
            <p>Configura tu perfil</p>
            <span>Personaliza tu foto y revisa tus datos disponibles.</span>
          </div>
        </v-card-title>

        <v-card-text>
          <input ref="profilePhotoInput" type="file" accept="image/*" class="d-none" @change="handlePhotoSelection" />
          <v-btn outlined color="primary" class="mb-4" @click="$refs.profilePhotoInput.click()">
            <v-icon left>mdi-camera-plus-outline</v-icon>
            Agregar o cambiar foto
          </v-btn>

          <v-list dense class="gpr-profile-dialog__data">
            <v-list-item>
              <v-list-item-icon><v-icon>mdi-account-outline</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Usuario</v-list-item-subtitle>
                <v-list-item-title>{{ profileForm.usuario || '-' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon><v-icon>mdi-card-account-details-outline</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Responsable</v-list-item-subtitle>
                <v-list-item-title>{{ profileForm.nombre || '-' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon><v-icon>mdi-email-outline</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Correo</v-list-item-subtitle>
                <v-list-item-title>{{ profileForm.email || '-' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Empresa activa</v-list-item-subtitle>
                <v-list-item-title>{{ profileForm.empresa || '-' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-checkbox
            v-model="profileDontShow"
            color="primary"
            dense
            hide-details
            label="No volver a mostrar"
            class="mt-3"
          />
        </v-card-text>

        <v-card-actions class="px-6 pb-6">
          <v-spacer />
          <v-btn text color="primary" @click="skipProfileConfig">Omitir</v-btn>
          <v-btn color="primary" depressed @click="saveProfileConfig">Configurar ahora</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';
import SidebarItems from './SidebarItems';
import { decryptAES } from '@/components4x/utils/utils4x';
import clientLogo from '@/assets/images/logo_cliente.png';
import clientMarkLogo from '@/assets/images/solo_logo_cliente.png';
export default {
  name: 'Sidebar',
  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    clientLogo,
    clientMarkLogo,
    usuarioname: '',
    items: SidebarItems,
    profileDialog: false,
    profileDontShow: false,
    profilePhoto: '',
    profilePreview: '',
    profileForm: {
      usuario: '',
      nombre: '',
      email: '',
      empresa: ''
    }
  }),
  computed: {
    ...mapState(['SidebarColor', 'SidebarBg']),
    Sidebar_drawer: {
      get() {
        return this.$store.state.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit('SET_SIDEBAR_DRAWER', val);
      }
    },
    ListPermissions() {
      return [...this.$store.getters.getFullPermissions];
    },
    profileName() {
      return this.profileForm.nombre || this.profileForm.usuario || 'Usuario';
    },
    profileRole() {
      return this.$store.getters.getRole || 'Usuario';
    },
    profileInitial() {
      const value = this.profileName || 'Usuario';
      return value
        .trim()
        .charAt(0)
        .toUpperCase();
    },
    profileTooltip() {
      return `${this.profileName} - ${this.profileRole}`;
    }
  },
  watch: {
    '$vuetify.breakpoint.smAndDown'(val) {
      this.$emit('update:expandOnHover', !val);
    }
  },

  methods: {
    verifyAuthAcl(code) {
      if (code === '*') return true;
      const index = this.ListPermissions.indexOf(code);
      return index !== -1;
    },
    isReadableProfileValue(value, maxLength = 80) {
      if (typeof value !== 'string') return false;
      const normalized = value.trim();
      if (!normalized || normalized.length > maxLength) return false;
      return !/^[A-Za-z0-9+/=_-]{48,}$/.test(normalized);
    },
    safeDecrypt(value) {
      try {
        return decryptAES(value);
      } catch (error) {
        void error;
        return '';
      }
    },
    getLocalProfileValue(key, maxLength) {
      const raw = localStorage.getItem(key) || '';
      const decrypted = this.safeDecrypt(raw);
      if (this.isReadableProfileValue(decrypted, maxLength)) return decrypted.trim();
      if (this.isReadableProfileValue(raw, maxLength)) return raw.trim();
      return '';
    },
    getProfileUserKey() {
      return this.profileForm.usuario || localStorage.getItem('lrd5qwlr674') || 'usuario';
    },
    getProfileStorageKey(suffix) {
      return `gpr-profile-${suffix}:${this.getProfileUserKey()}`;
    },
    loadProfileContext() {
      this.usuarioname = this.getLocalProfileValue('user', 30);
      this.profileForm.usuario = this.usuarioname;
      this.profileForm.nombre = this.getLocalProfileValue('nc4rhtcc976', 80) || this.usuarioname;
      this.profileForm.email = this.getLocalProfileValue('iow5csjr398', 80);
      this.profileForm.empresa = this.safeDecrypt(localStorage.getItem('emp')) || '';
      this.profilePhoto = localStorage.getItem(this.getProfileStorageKey('photo')) || '';
      this.profilePreview = this.profilePhoto;
      this.profileDontShow = localStorage.getItem(this.getProfileStorageKey('hidden')) === '1';
    },
    openProfileConfig(isInitial = false) {
      if (typeof isInitial !== 'boolean') isInitial = false;
      this.loadProfileContext();
      if (isInitial && this.profileDontShow) return;
      this.profileDialog = true;
    },
    handlePhotoSelection(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.profilePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    saveProfileConfig() {
      if (this.profilePreview) {
        localStorage.setItem(this.getProfileStorageKey('photo'), this.profilePreview);
        this.profilePhoto = this.profilePreview;
      }
      if (this.profileDontShow) {
        localStorage.setItem(this.getProfileStorageKey('hidden'), '1');
      } else {
        localStorage.removeItem(this.getProfileStorageKey('hidden'));
      }
      window.dispatchEvent(new CustomEvent('gpr-profile-updated'));
      this.profileDialog = false;
    },
    skipProfileConfig() {
      if (this.profileDontShow) {
        localStorage.setItem(this.getProfileStorageKey('hidden'), '1');
      } else {
        localStorage.removeItem(this.getProfileStorageKey('hidden'));
      }
      this.profileDialog = false;
    }
  },
  created() {
    this.loadProfileContext();
  },
  mounted() {
    window.addEventListener('gpr-open-profile-config', this.openProfileConfig);
    this.$nextTick(() => this.openProfileConfig(true));
  },
  beforeDestroy() {
    window.removeEventListener('gpr-open-profile-config', this.openProfileConfig);
  }
};
</script>
<style lang="scss">
#main-sidebar {
  box-shadow: 1px 0 20px rgba(15, 23, 42, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(15, 23, 42, 0.08);

  .v-navigation-drawer__border {
    display: none;
  }

  .v-list {
    padding: 10px 12px 18px;
  }

  .gpr-sidebar-head {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 12px 12px 8px;
    padding: 14px 14px 10px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--gpr-primary, #c41230) 0%, var(--gpr-primary-dark, #9f1028) 100%);
    color: #ffffff;
    overflow: hidden;
  }

  .gpr-sidebar-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 58px;
    width: 100%;
    padding: 2px 6px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .gpr-sidebar-brand__logo {
    display: block;
    object-fit: contain;
  }

  .gpr-sidebar-brand__logo--full {
    width: 100%;
    max-width: 218px;
    height: 50px;
  }

  .gpr-sidebar-brand__logo--mark {
    display: none;
    width: 34px;
    height: 34px;
  }

  .v-list-item {
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
  }

  .gpr-sidebar-profile {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    min-height: 46px;
    padding: 9px 0 0;
    color: #ffffff;
    cursor: pointer;
    transition: opacity 0.16s ease;
  }

  .gpr-sidebar-profile:hover,
  .gpr-sidebar-profile:focus-within {
    opacity: 0.92;
  }

  .gpr-sidebar-profile__avatar {
    flex: 0 0 auto;
    color: var(--gpr-primary, #c41230);
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.38);
    font-size: 13px;
    font-weight: 800;
  }

  .gpr-sidebar-profile__info {
    min-width: 0;
    flex: 1 1 auto;
  }

  .gpr-sidebar-profile__name,
  .gpr-sidebar-profile__role {
    margin: 0;
    letter-spacing: 0;
  }

  .gpr-sidebar-profile__name {
    color: #ffffff;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-word;
  }

  .gpr-sidebar-profile__role {
    color: rgba(255, 255, 255, 0.74);
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .gpr-sidebar-profile__action {
    color: rgba(255, 255, 255, 0.9);
    flex: 0 0 auto;

    &:hover,
    &:focus {
      background: rgba(255, 255, 255, 0.14);
    }
  }

  &.v-navigation-drawer--mini-variant {
    .gpr-sidebar-head {
      margin: 10px 7px 8px;
      padding: 8px 6px;
      border-radius: 9px;
    }

    .gpr-sidebar-brand {
      min-height: 42px;
      padding: 0 0 8px;
    }

    .gpr-sidebar-brand__logo--full {
      display: none;
    }

    .gpr-sidebar-brand__logo--mark {
      display: block;
      width: 36px;
      height: 36px;
    }

    .gpr-sidebar-profile {
      justify-content: center;
      min-height: 38px;
      padding: 8px 0 0;
      gap: 0;
    }

    .gpr-sidebar-profile__info,
    .gpr-sidebar-profile__action {
      display: none;
    }

    .gpr-sidebar-profile__avatar {
      height: 34px !important;
      min-width: 34px !important;
      width: 34px !important;
    }
  }
}

.gpr-profile-dialog {
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: 0 20px 56px rgba(15, 23, 42, 0.22) !important;

  .gpr-profile-dialog__title {
    display: flex;
    gap: 16px;
    align-items: center;
    padding: 24px 24px 8px;

    p {
      margin: 0;
      color: #1f2937;
      font-size: 1.2rem;
      font-weight: 700;
      letter-spacing: 0;
    }

    span {
      color: #64748b;
      font-size: 0.88rem;
      font-weight: 400;
    }
  }

  .gpr-profile-dialog__avatar {
    color: #c41230;
    background: #fbecef;
    border: 1px solid rgba(196, 18, 48, 0.2);
  }

  .gpr-profile-dialog__data {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #ffffff;

    .v-list-item__icon {
      margin-right: 14px;

      .v-icon {
        color: #c41230;
      }
    }
  }
}
</style>
